import {createApp} from "vue";
import App from "./App.vue";
import router from "./router";
import {createStore} from 'vuex'
import createdPersistedState from "vuex-persistedstate"
import jQuery from 'jquery'
import FreeWorld from "@/assets/js/FreeWorld";

import "../src/assets/css/bootstrap/css/bootstrap.min.css";
import "../src/assets/css/style.css";

// localStorage.setItem("DOM", "https://market-app.ir/");
let user_id = localStorage.getItem('uid')
if (user_id !== undefined && user_id !== null) {
    user_id = FreeWorld.PinkMan(localStorage.getItem('uid'), 'de')
}

const store = createStore({
    state() {
        return {

            country: null,
            category: null,
            slider: null,
            profile: null,
            add_advertising: null,
            advertising: null,
            name_new_service: null,
            info: {
                support: null,
            },
            user_type: null,
            filter:{
                workers: null,
                advertising: null,
                HomePage: null,
            },
            chat: null,
            helpers: false,
        }
    },
     mutations: {

        set_country(state, new_value) {
            let data = FreeWorld.PinkMan(new_value , 'en')
            state.country = data
        },

        set_category(state, new_value) {
            let data = FreeWorld.PinkMan(new_value , 'en')
            state.category = data
        },

        set_user_type(state, new_value) {
            let data = FreeWorld.PinkMan(new_value , 'en')
            state.user_type = data
        },

        set_slider(state, new_value) {
            let data = FreeWorld.PinkMan(new_value , 'en')
            state.slider = data
        },

        set_profile(state, new_value) {
            let data = FreeWorld.PinkMan(new_value , 'en')
            state.profile = data
        },

        set_info_support(state, new_value) {
            let data = FreeWorld.PinkMan(new_value , 'en')
            state.info.support = data
        },

        set_filter_workers(state, new_value) {
            if (new_value === 'delete'){
                state.filter.workers = null
            }else {
                let data = FreeWorld.PinkMan(new_value, 'en')
                state.filter.workers = data
            }
        },

        set_filter_advertising(state, new_value) {
            if (new_value === 'delete'){
                state.filter.advertising = null
            }else {
                let data = FreeWorld.PinkMan(new_value, 'en')
                state.filter.advertising = data
            }
        },

        set_filter_homepage(state, new_value) {

            state.filter.HomePage = FreeWorld.PinkMan(new_value, 'en')

        },

        set_add_advertising(state, new_value) {
            if (new_value === 'delete'){
                state.add_advertising = null
            }else {
                let data = FreeWorld.PinkMan(new_value, 'en')
                state.add_advertising = data
            }
        },

        set_advertising(state, new_value) {
            if (new_value === 'delete'){
                state.advertising = null
            }else {
                let data = FreeWorld.PinkMan(new_value, 'en')
                state.advertising = data
            }
        },

        set_name_new_service(state, new_value) {
            if (new_value === 'delete'){
                state.name_new_service = null
            }else {
                let data = FreeWorld.PinkMan(new_value, 'en')
                state.name_new_service = data
            }
        },

        set_chat(state, new_value) {
            if (new_value === 'delete'){
                state.chat = null
            }else {
                let data = FreeWorld.PinkMan(new_value, 'en')
                state.chat = data
            }
        },

        set_helpers(state, new_value) {
           state.helpers = new_value
        },

        empty_state() {

            store.replaceState({

                country: null,
                slider: null,
                profile: null,
                info: {
                    support: null,
                },
                user_type: null,
                version: '1.0.0',

            })

        },

    },
    actions:{},

    plugins: [createdPersistedState()]

})
export default store;

// localStorage.clear()
// store.commit('empty_state')


// import "vuetify/styles";
// import {createVuetify} from "vuetify";
// import * as components from "vuetify/components";
// import * as directives from "vuetify/directives";
// import {aliases, fa} from 'vuetify/iconsets/fa'
// import {mdi} from 'vuetify/iconsets/mdi';
//
// const vuetify = createVuetify({
//     components,
//     directives,
//     icons: {
//         defaultSet: 'mdi',
//         aliases,
//         sets: {
//             fa,
//             mdi,
//         },
//     },
//
// });


const app = createApp(App);

app.use(router);
// app.use(vuetify);
app.use(store);
app.use(jQuery);
app.mount("#app");